// extracted by mini-css-extract-plugin
module.exports = {"sourceDetails":"ArticleHeroImageSource_sourceDetails__65dZr","heroImageSource":"ArticleHeroImageSource_heroImageSource__u4f_m"};